import { Grid, MenuItem, Select, Switch, TextField } from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { BsNature } from "../../../models/BsNature";
import { VendorTitle } from "../../../models/VendorTitle";
import { PaymentPurpose } from "../../../models/PaymentPurpose";
import { VendorDetailState } from "../../../reducers/vendor/VendorDetailReducer";
import { RootState } from "../../../reducers";
import { useSelector } from "react-redux";
import AllActions from "../../../actions";
import { useEffect } from "react";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { VendorDetailBasicMeta } from "../../../models/VendorDetail/VendorDetailBasicMeta";
import {
  FieldsLengthConstants,
  FileUploadTypes,
  NatureOfBusiness,
  RequestStatus,
} from "../../../constants/AppConstants";
import FileUpload from "../../../components/FileUpload/FileUpload";

export default function IndividualPaymentInfo(props: any) {
  const classes = useStyles();
  const {
    getErrorState,
    handleChange,
    prepareForRequest,
    compeleteRequest,
    isEditableMode,
    isDisplayRegistrationNumber,
    bsnature,
    vendotitle,
    handleOnBlur,
    getCompareField
  } = props;

  // const [bsnature, setBsnature] = useState(Array<BsNature>());
  //const [vendotitle, setVendotitle] = useState(Array<VendorTitle>());
  const [paymentpurpose, setPaymentpurpose] = useState(Array<PaymentPurpose>());
  //const [incotermsList, setIncotermsList] = useState(Array<PaymentPurpose>());
  // const [schemaGroupList, setSchemaGroupList] = useState(Array<PaymentPurpose>());

  const [isPvtNture, setIsPvtNture] = useState(false);
  const [isMasNature, setIsMasNature] = useState(false);
  const [isOtherNature, setIsOtherNature] = useState(false);
  const [isPublicnature, setPublicNature] = useState(false);

  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  console.log('vendorDetail', vendorDetail)

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.formOneWrapper}
      >
        <Grid
          className={classes.compDisableCls}
          item
          container
          xs={12}
          sm={12}
          md={6}
          lg={4}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
            {translation.individualPayPopup_individual_pay_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.formOneinputWrapper}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ width: "50%", float: "left" }}
          >
            <div className={classes.switchDiv}>
              <Switch
                checked={vendorDetail.isIndividualPayement}
              ></Switch>
            </div>
          </Grid>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_bankdetails_housebank_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.HouseBank}</span>
          </Grid>
        </Grid> */}
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_est_sales_turnover_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.estimatedSalesTurnover}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_no_of_invoice_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.noOfInvoicesPerMonth}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_supplier_bank_acc_name_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.supplierCBankName}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_supplier_bank_acc_swift_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.supplierCBankAccountSWIFT}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_goods_desc_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.descOfGoods}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} className={!isEditableMode ? classes.compDisableCls : ""}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.individualPayPopup_supplier_hs_codes_lbl}
            </span>
          </Grid>
          <Grid
            className={classes.inputWrapper_Req}
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <span className={classes.textWrap}>{vendorDetail.offShoreSupplierHSCode}</span>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
